module.exports = __webpack_public_path__ + "img/symbol_9.ef33d1d1.png";